import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';

export default class InvestorInvestmentPagedLookupCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Nullable()
    public investorId: number | null = null;

    @Attributes.Nullable()
    @Attributes.Integer()
    public investorInvestmentId: number | null = null;

    @Attributes.Nullable()
    public issuerInvestmentId: number | null = null;

    @Attributes.Nullable()
    public entityId: number | null = null;

    @Attributes.Nullable()
    public productTypeId: number | null = null;
    
    public showUnauthorised: boolean = false;

    public showInactive: boolean = false;

    public investorName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Investor Investment Paged Lookup Criteria";
    }
}